import React from 'react';
import common from '@/common/common.js'

export default class AuthMenu extends React.Component {
    state = {
        authUrls: common.getlocalItem('auth-menus') ? common.getlocalItem('auth-menus') : [],
        url: this.props.url,
        flag: false,
    }

    componentWillMount = () => {
        this.urlAuth();
    }

    urlAuth = () => {
        let flag = false;
        const { url, authUrls } = this.state;
        if (url && authUrls && authUrls.length > 0) {
            authUrls.map(item => {
                if (item.url === url) {
                    flag = true;
                }
            });
        }
        this.setState({ flag });
    }

    render() {
        const { flag } = this.state;
        return (
            flag ? this.props.children : null
        )
    }
}